import { render, staticRenderFns } from "./DataDictionaryLayout.vue?vue&type=template&id=8ec63720&scoped=true&"
import script from "./DataDictionaryLayout.vue?vue&type=script&lang=js&"
export * from "./DataDictionaryLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionaryLayout.vue?vue&type=style&index=0&id=8ec63720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec63720",
  null
  
)

export default component.exports